import { useRef } from 'react';
import logo from "../../assets/logos/TRANSKYRIOS-_IconColor.avif";
import ContactoTI from "../../components/contacto-ti/contacto-ti";
import { Toast } from 'primereact/toast';
import './gestion-personas.css'

function VerPersonas() {
  const toast = useRef(null);

  return (
    <div className="per-container">
      <Toast ref={toast} />

      <header className="inv-header">
        <h2 className='mt-2 mb-3'>Gestión de Personas</h2>
        <img src={logo} alt="Transkyrios" className="inv-logo" />
      </header>

      <section className="per-content">
        <ContactoTI />
      </section>
    </div>
  );
}

export default VerPersonas